/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
import { useEffect } from "react";

const Iugu = {
  setAccountToken(token: any) {
    // console.log('token', token);
    (window as any).Iugu?.setAccountID(token);
  },

  setTestMode(mode: boolean) {
    (window as any).Iugu?.setTestMode(mode);
  },

  async createPaymentToken(form: any) {
    form.year = form.year.length === 2 ? "20".concat(form.year) : form.year;
    return new Promise(resolve => {
      (window as any).Iugu?.createPaymentToken(form, (response: any) => {
        resolve(response);
      });
    });
  },
  ...(window as any)?.Iugu
};

export default function useIugu(accountId: string) {
  useEffect(() => {
    if (document.getElementById("iugu-script")) {
      Iugu?.setAccountToken(accountId);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://js.iugu.com/v2";
    script.type = "text/javascript";
    script.id = "iugu-script";

    script.onload = () => {
      Iugu?.setAccountToken(accountId);
    };

    document.head.appendChild(script);

    return () => document.getElementById("iugu-script")?.remove();
  }, [accountId]);

  return Iugu;
}
